import React from "react";
import { useSelector } from "react-redux";
import { commonIcon } from "../../asset";
import { CHAT_TYPE } from "../../constants/index";

const BranchText = ({ hasChatType }) => {
  const chatType = useSelector((state) => state.chat.chatType);

  // Function to get display name for chat type
  const getChatTypeDisplayName = (type) => {
    switch (type) {
      case CHAT_TYPE.GEMINI_BETA_PUBLIC:
        return "Public Gemini";
      case CHAT_TYPE.GEMINI_BETA_PRIVATE:
        return "Private Gemini";
      case CHAT_TYPE.PRIVATE_O3:
        return "Private O3";
      case CHAT_TYPE.PUBLIC_O3:
        return "Public O3";
      case CHAT_TYPE.GPT_PRIVATE:
        return "GPT Private";
      case CHAT_TYPE.GPT_PUBLIC:
        return "GPT Public";
      case CHAT_TYPE.PRIVATE:
        return "Private";
      case CHAT_TYPE.PRIVATE_V2:
        return "Private 2.0";
      case CHAT_TYPE.PUBLIC:
        return "Public";
      case CHAT_TYPE.DEEPSEEK:
        return "DeepSeek";
      default:
        return type ? type.replace("_", " ") : "";
    }
  };

  return (
    <div className="flex items-center justify-center gap-2 capitalize">
      <img
        src={commonIcon.chatGeminiIcon}
        className="!size-6"
        alt="Gospel Truth"
      ></img>
      <p className="flex items-center gap-1 !font-semibold whitespace-nowrap text-base">
        <span className="text-[#231F20]">Gospel</span>
        <span className="text-[#7B7C7F]">Truth</span>
        {hasChatType && chatType && (
          <span className="text-indigo-900">{getChatTypeDisplayName(chatType)}</span>
        )}
      </p>
    </div>
  );
};

export default BranchText;
